// Route-level platform guard. Wrap player / scout route blocks with
// `<Route element={<PlatformGuard allow="native" />}>` to enforce the
// "web app = Academy only" rule: any direct attempt to hit
// /player/* or /scout/* on the web bounces to /auth (which itself
// forces Academy persona on web).
//
// Native rendering passes through via <Outlet />, keeping the standard
// React Router nested-route pattern intact.

import { Navigate, Outlet } from "react-router-dom";
import { isWebPlatform } from "@/lib/platform";

interface PlatformGuardProps {
  /**
   * Which platform is allowed past the guard.
   *   - "native" → web users get redirected to /auth.
   *   - "web"    → native users get redirected to /auth (currently
   *                unused — kept for symmetry).
   */
  allow: "native" | "web";
}

const PlatformGuard = ({ allow }: PlatformGuardProps) => {
  const onWeb = isWebPlatform();
  const blocked =
    (allow === "native" && onWeb) || (allow === "web" && !onWeb);
  if (blocked) return <Navigate to="/auth" replace />;
  return <Outlet />;
};

export default PlatformGuard;
